import React, { FunctionComponent } from "react";

interface ISectionImageHeaderProps {
    imagePath: string;
}

const SectionImageHeader: FunctionComponent<ISectionImageHeaderProps> = (props) => (
    <div className="section-image-header w-full">
        <div className="section-image-header__image" style={{backgroundImage: `url('${props.imagePath}')`}} />
    </div>
);

export default SectionImageHeader
